import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { NFTextAreaInput } from "../../../Shared/NewForms/NFTextAreaInput";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";

export const SetItemsPricesAdditional = () => {
  const { t } = useTranslation();

  return (
    <Row>
      <Col sm={12}>
        <NFTextAreaInput
          fieldName={"comment"}
          title={t("Comment")}
          required={false}
        />
      </Col>
    </Row>
  );
};
